import React from "react";
var __jsx = React.createElement;
import stl from "./ViewAllOfferedDocComponent.module.css";
import { Link } from "react-router-dom";
import ViewOfferedDocuments from "../StepDetailsComponent_TS/StepBody/ViewOfferedDocuments/ViewOfferedDocuments";
import { useTranslation } from "@i18n";
import useHelpers from "@hooks/useHelpers";
var ViewAllOfferedDocComponent = function ViewAllOfferedDocComponent(_ref) {
  var _allOfferedDoc$docume;
  var isFinance = _ref.isFinance,
    orderId = _ref.orderId,
    allOfferedDoc = _ref.allOfferedDoc;
  var _useTranslation = useTranslation(["web_tracking"]),
    t = _useTranslation.t;
  var _useHelpers = useHelpers(),
    createUrl = _useHelpers.createUrl;
  var hasInspectionReport = allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.documents.some(function (item) {
    return item.is_inspection_report === true;
  });
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: stl.viewAllDocContainer
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.Header
  }, /*#__PURE__*/React.createElement("div", {
    className: stl.carDetails
  }, /*#__PURE__*/React.createElement("p", null, t("yor_car", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement(Link, {
    className: hasInspectionReport ? "disableEvents" : undefined,
    to: createUrl("/car-info/".concat(allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.post_id, "?isCancelled=").concat(allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.is_cancelled))
  }, /*#__PURE__*/React.createElement("p", {
    className: stl.link
  }, allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.post_title))), /*#__PURE__*/React.createElement("div", {
    className: stl.orderDetails
  }, /*#__PURE__*/React.createElement("p", null, t("order", {
    ns: "web_tracking"
  })), /*#__PURE__*/React.createElement("p", null, orderId))), /*#__PURE__*/React.createElement("div", {
    className: stl.documents
  }, (allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : (_allOfferedDoc$docume = allOfferedDoc.documents) === null || _allOfferedDoc$docume === void 0 ? void 0 : _allOfferedDoc$docume.length) > 0 ? /*#__PURE__*/React.createElement(ViewOfferedDocuments, {
    offered_documents: allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.documents,
    g4_data: allOfferedDoc === null || allOfferedDoc === void 0 ? void 0 : allOfferedDoc.g4_data,
    isFinance: isFinance
  }) : /*#__PURE__*/React.createElement("p", {
    className: stl.noDocuments
  }, t("documents_attached", {
    ns: "web_tracking"
  })))));
};
export default ViewAllOfferedDocComponent;